import { render } from "./message.vue?vue&type=template&id=fa40adb6&scoped=true"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"

import "./message.vue?vue&type=style&index=0&id=fa40adb6&scoped=true&lang=css"
import "./message.vue?vue&type=style&index=1&id=fa40adb6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa40adb6"]])

export default __exports__